import { useEffect, useState } from "react";
import { v5 as uuidv5 } from "uuid";
import { DEFAULT_UID_NAMESPACE } from "../helpers/uuid";

export interface IUseIdProps {
  id?: string;
  name?: string;
  NS?: string;
}

export const USE_ID_DEFAULT_PROPS: IUseIdProps = {
  id: null,
  name: "dynamicIds",
  NS: DEFAULT_UID_NAMESPACE,
};

/**
 *  Generates an id if none was passed in.
 * */
function useId(props: IUseIdProps) {
  const { id, name, NS } = {
    ...USE_ID_DEFAULT_PROPS,
    ...props,
  };

  /** State passed as fn to make only 1 call to uuidv5 */
  const [currentId, setCurrentId] = useState(() => id || uuidv5(name, NS));
  useEffect(() => {
    setCurrentId(id || uuidv5(name, NS));
  }, [NS, id, name]);

  return [currentId, setCurrentId] as const;
}

export default useId;
